import { render } from "./App.vue?vue&type=template&id=2a006b8b&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=2a006b8b&lang=scss"

import exportComponent from "/jenkins-tmp/workspace/Recruiting-PP6/Oidcserver/development@2/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__